@if (hasLabel) {
  <div class="field-label">{{label}}
    @if (isMandatory) {
      <span class="required">(*)</span>
      }:
    </div>
  }
  <div [class]="'w-full rounded-lg border border-neutral-300 bg-white ' + height"
    [class.bg-neutral-50]="readOnly" [class.opacity-60]="disabled"
    (click)="handleFocus($event, textarea)">
    <div class="h-full text-area-historical ">
      @if (originalValue) {
        <div class="whitespace-pre-line" [innerHtml]="originalValue | safeHtml">
        </div>
      }
      <textarea #textarea
        class="sz-textarea border-0 shadow-none focus:ring-0"
        [(ngModel)]="value"
        [readonly]="readOnly"
        [disabled]="disabled"
        [style.height.px]="120"
        [maxlength]="maxLength"
        [placeholder]="placeholder || ''"
        [required]="isMandatory"
        (keyup)="handleKeyUp($event)"
      (input)="handleValueChanged($event)"></textarea>
      @if (showCharacterCount) {
        <div class="text-right text-sm text-neutral-500">
          {{valueCounting}}/{{maxLength}}
        </div>
      }
    </div>
  </div>